import React from 'react';

const TeachingPage = () => {
  return <div>TeachingPage</div>;
};

export default TeachingPage;
